import React, { useEffect, useState, useContext } from 'react';
import { CardContent, CardHeader, Container, Expandable, IconsContainer, ContentTextArea, ButtonContent, TextArea } from './styles'
import Icon from 'components/Icon';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import Button, { ButtonContainer } from '../../components/Button';
import moment from 'moment';
import Colors from "constants/Colors";
import Label from '../../components/Form/Label';
import { FiraSansBold, FontWeight } from '../../components/Text';

export default function NotesAccordionV2(props) {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState("");
  const [notes, setNotes] = useState("");
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  function handleUpdateNotes() {
    let valueFormatted = `Nome: ${authContext.login_response.ret_value.firstName} ${authContext.login_response.ret_value.lastName}, Data: ${moment().format("D/MM/YYYY, kk:mm:ss")}` + '\n' + value;
    let newValue = props.question.answer ? valueFormatted + '\n \n' + props.question.answer : valueFormatted;

    if (value.trim() != "") {
      props.onChange(newValue);
    }
    setIsEditing(false);
    setValue("")
    handleGetNotes()
  };

  function handleGetNotes() {
    if (props.question.answer) {
      setNotes(props.question.answer)
    }
  };

  useEffect(() => {
    handleGetNotes();
  }, [props.question.answer])

  return (
    <Container>
      <CardHeader>
        <Label
          weight={FontWeight.SemiBold}
          hideLabelAsterisk={true}
          bold={props.bold}
        >
          {props.question.dsQuestion}
        </Label>
        <IconsContainer>
          <Icon
            name="add"
            className="icon-add"
            disabled={props.disabled}
            onClick={() => {
              setIsEditing(true)
            }}
          />
        </IconsContainer>
      </CardHeader>
      <CardContent className={'expanded'}>
        <Expandable>
          <ContentTextArea>
            <TextArea
              value={isEditing ? value : notes}
              onChange={(e) => setValue(e.target.value)}
              disabled={!isEditing}
            />
            {isEditing
              ? (
                <ButtonContainer style={{ justifyContent: 'flex-end' }}>
                  <Button
                    id="btnLost"
                    onClick={() => {
                      setIsEditing(false)
                      setValue("")
                    }}
                    third
                  >
                    {"CANCELAR"}
                  </Button>

                  <Button
                    id="btnSave"
                    type="submit"
                    onClick={() => handleUpdateNotes()}
                    primary
                    style={{ backgroundColor: Colors.PRIMARY1 ? Colors.PRIMARY1 : 'none' }}
                  >
                    SALVAR
                  </Button>
                </ButtonContainer>
              ) : null
            }

          </ContentTextArea>
        </Expandable>
      </CardContent>
    </Container>
  );
}
